import NewsNotes from './NewsNotes';

export default NewsNotes;
